import React from 'react'
import { InfoCircleIcon } from './icons/InfoCircle.jsx'
import { GearIcon } from './icons/Gear.jsx'
import { SignOutIcon } from './icons/SignOut.jsx'
import { ChecklistIcon } from './icons/Checklist.jsx'
import { CloseIcon } from './icons/Close.jsx'
import { CheckIcon } from './icons/Check.jsx'
import { ChevronRightIcon } from './icons/ChevronRight.jsx'
import { ChevronLeftIcon } from './icons/ChevronLeft.jsx'
import { ExternalLinkIcon } from './icons/ExternalLink.jsx'
import { MegaphoneIcon } from './icons/Megaphone.jsx'

const REGISTRY = {
  'info-circle': InfoCircleIcon,
  gear: GearIcon,
  'sign-out': SignOutIcon,
  checklist: ChecklistIcon,
  close: CloseIcon,
  check: CheckIcon,
  'chevron-right': ChevronRightIcon,
  'chevron-left': ChevronLeftIcon,
  'external-link': ExternalLinkIcon,
  megaphone: MegaphoneIcon,
}

/**
 * Renders one of the registered SVG icons. Pass `name` and (optionally) `size`.
 * Icons inherit colour from `currentColor`, so set `color` on the parent.
 */
export function Icon({ name, size = 16, ...rest }) {
  const Component = REGISTRY[name]
  if (!Component) {
    if (typeof console !== 'undefined') {
      console.warn(`<Icon name="${name}" /> not found in registry`)
    }
    return null
  }
  return <Component size={size} {...rest} />
}

// Re-export individual icons for callers that prefer direct imports
// (e.g., the moved Sidebar/TasksNavEntry icons).
export {
  InfoCircleIcon,
  GearIcon,
  SignOutIcon,
  ChecklistIcon,
  CloseIcon,
  CheckIcon,
  ChevronRightIcon,
  ChevronLeftIcon,
  ExternalLinkIcon,
  MegaphoneIcon,
}
